import { SiteFooter } from "../shell/SiteFooter";
import { useSmoothScroll } from "../shell/smooth-scroll";
import { EventNav } from "./EventNav";
import { Hero } from "./Hero";
import { eventFacts, useEventQuery } from "./queries";
import {
  AboutSection,
  ClosingBand,
  PerksSection,
  SpeakersSection,
  ThemeSection,
  VenueSection,
} from "./Sections";

/** `/`: the event on iForte's mural wall, and every door into registration. */
export function EventPage() {
  const event = useEventQuery();
  const facts = eventFacts(event.data?.event);
  useSmoothScroll();

  return (
    <div className="relative isolate min-h-dvh overflow-x-clip">
      <EventNav />
      <main id="main" tabIndex={-1} className="outline-none">
        <Hero facts={facts} />
        <AboutSection facts={facts} />
        <ThemeSection />
        <SpeakersSection />
        <PerksSection />
        <VenueSection facts={facts} />
        <ClosingBand />
      </main>
      <SiteFooter />
    </div>
  );
}
